import { PageInfo } from "@/components/Pagination";
import { TypedDocumentNode, gql } from "@apollo/client";
import { CRM_NOTE_FIELDS_FRAGMENT, PERSON_FRAGMENT } from "@/fragments";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import { OrderNode } from "@/pages/billing/types";

type Query = {
  commerceOrders: {
    totalCount: number;
    nodes: OrderNode[];
    pageInfo: PageInfo;
  };
};

export const ORDERS_QUERY: TypedDocumentNode<Query> = gql`
  query GetCommerceOrders(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $ids: [String!]
    $statuses: [String!]
    $templates: [String!]
    $facilityId: String
    $datetimeRange: DateTimeRangeInput
  ) {
    commerceOrders(
      first: $first
      last: $last
      after: $after
      before: $before
      filters: {
        search: $query
        ids: $ids
        status: $statuses
        template: $templates
        facilityId: $facilityId
        datetimeRange: $datetimeRange
      }
    ) {
      nodes {
        id
        status
        paymentStatus
        balance
        dueDate
        payable
        type
        updatedAt
        description
        person {
          id
          firstName
          lastName
          profilePhoto
          pgaId
          mainProgramType {
            id
            name
          }
        }
        lineItems {
          id
          name
          quantity
          priceCents
          totalPrice
          fee
        }
        notes {
          ...CRMNoteFields
        }
      }
      ...PageInfo
    }
  }

  ${PAGE_INFO_FRAGMENT}
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export const GET_PAYORS = gql`
  query GetPayors($input: BackofficeCRMPeopleInput!) {
    people(input: $input) {
      nodes {
        ...PersonFragment
      }
    }
  }
  ${PERSON_FRAGMENT}
`;

export const GET_TEMPLATES = gql`
  query GetTemplates {
    commerceOrderTemplates {
      id
      name
      type
      lookupKey
    }
  }
`;

export const CREATE_DRAFT_ORDER_MUTATION = gql`
  mutation CreateDraftOrder($input: CommerceCreateDraftOrderInput!) {
    commerceCreateDraftOrder(input: $input) {
      order {
        id
        status
      }

      message
      success
    }
  }
`;

export const PERSON_DRAFT_DUES_ORDERS_QUERY = gql`
  query GetPersonsOrders($filters: BackofficeCommerceOrderInput!) {
    commerceOrders(filters: $filters) {
      totalCount
      nodes {
        id
        status
        type
        person {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
